import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useSearchParams } from 'wouter'
import { useCADQuery } from '@/services/queries/cads'
import { useCADPageStore } from '@/state'
import { useOperationSteps } from '@/services/queries/operation_steps'
import { useDocumentPageQuery } from '@/pages/DocumentPage/queries'

export const useOpenStepOnLoad = () => {
  const { isLoading: isLoadingSteps, steps } = useOperationSteps()
  const { isLoading: isLoadingDocument, data: docData } = useDocumentPageQuery()
  const { isLoading: isLoadingCad, data: cadData } = useCADQuery()

  const getCadPageState = useCADPageStore(useShallow((state) => state.getState))
  const setCadPageState = useCADPageStore(useShallow((state) => state.setState))
  const cadLoaded = useCADPageStore((state) => state.cadLoaded)

  const [searchParams] = useSearchParams()

  const documentId = docData?.doc?.id as string
  const isLoading = isLoadingCad || isLoadingDocument || isLoadingSteps

  const selectCurrentStep = async () => {
    const pageId = searchParams.get('page_id')
    const gltf = cadData.gltf
    const assemblyTree = cadData.rawAssemblyTree
    const cadPageState = getCadPageState()
    const hiddenParts = cadPageState.hiddenParts
    const explosions = cadPageState.explosions
    const activeStep = steps?.find((step) => step.id === pageId)
    const isExplosionLinesEnabled = cadPageState.isExplosionLinesEnabled
    const step = steps.find((s) => s.id === pageId)
    const stepsAtLevel = steps.filter((s) => s.parent === activeStep?.parent)
    const showFullModel = cadPageState.showFullModel
    const hidePreviousOperations = cadPageState.hidePreviousOperations

    if (!assemblyTree || !gltf) return

    if (pageId) {
      setCadPageState({
        subAssemblyDocumentPageId: step?.parent,
        selectedParts: [],
        operationStep: {
          documentId,
          stepId: pageId,
          selectFromCad: false,
          isActive: true,
        },
      })

      gltf?.setVisibilityForOperationSteps({
        assemblyTree,
        steps: stepsAtLevel,
        activeStep,
        hiddenParts,
        explosions,
        isExplosionLinesEnabled,
        showFullModel,
        hidePreviousOperations,
      })

      const stepContainer = document.getElementById(`step-${pageId}`)
      if (stepContainer) {
        stepContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
    }
  }

  useEffect(() => {
    if (!isLoading && cadLoaded) {
      selectCurrentStep().catch(() => {})
    }
  }, [isLoading, cadLoaded])
}
